import { Query } from "src/app/shared/ddd/models/query";

export class ItemFormQuery implements Query {
  inspectionId: string;
  itemId: string;

  constructor(inspectionId: string, itemId: string) {
    this.inspectionId = inspectionId;
    this.itemId = itemId;
  }
}
